import { ChevronLeftIcon } from '@heroicons/react/24/outline';

export const OnboardingStep = ({
  title,
  description,
  children,
  currentStep,
  totalSteps,
  isFirstStep,
  isLastStep,
  canGoNext,
  canGoPrevious,
  onNext,
  onPrevious,
  onClose,
  onSkip,
  customActions
}) => {
  return (
    <div
      className="flex flex-col h-full p-6 md:p-6"
    >
      {/* Header con botones Atrás y Saltar */}
      <div className="flex justify-between items-start mb-8">
        <div className="flex items-center">
          {canGoPrevious && (
            <button
              onClick={onPrevious}
              className="text-xs text-white hover:text-[#FFB447] transition-colors flex items-center gap-1"
            >
              <ChevronLeftIcon className="w-3 h-3" />
              Atrás
            </button>
          )}
        </div>
        
        <button
          onClick={onClose}
          className="text-xs text-white hover:text-[#FFB447] transition-colors"
        >
          Saltar
        </button>
      </div>


      {/* Contenido principal */}
      <div className="flex-1 flex flex-col justify-center min-h-0">
        {children}
      </div>

      {/* Footer con indicadores y botón Continuar */}
      <div className="pt-6">
        {/* Indicadores de paginación */}
        <div className="flex justify-center items-center gap-2 mb-4">
          {Array.from({ length: totalSteps }).map((_, index) => (
            <div
              key={index}
              className={`w-[9px] h-[9px] rounded-full transition-colors ${
                index + 1 === currentStep ? 'bg-[#FFB447]' : 'bg-gray-300'
              }`}
            />
          ))}
        </div>
        
        <button
          onClick={onNext}
          className="w-full bg-[#FFB447] hover:bg-[#E6A041] text-black font-medium py-2 px-6 rounded-lg transition-colors"
        >
          {isLastStep ? 'Comenzar' : 'Continuar'}
        </button>
      </div>
    </div>
  );
};